import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Label } from "components/input/Label";
import Endereco from "model/transportes/endereco/Endereco";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { fromLatLng, geocode, OutputFormat, RequestType, setDefaults } from "react-geocode";
import "./enderecoEdit.scss";
import { InputTextarea } from "primereact/inputtextarea";

type Props = {
    value: Endereco;
    onChange: (value: Endereco) => void;
}

export default function EnderecoEdit(props: Props) {
    const keyMaps = 'AIzaSyDQbLYImEY_K1U92ocx6-e46qC2AjskIfo';
    const [localizacao, setLocalizacao] = useState<{ lat: number, lng: number } | null>(null);
    const [center, setCenter] = useState({ lat: -28.6782, lng: -49.370176 });

    const [termoBusca, setTermoBusca] = useState<string>("");
    const [sugestoes, setSugestoes] = useState<any[]>([]);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: keyMaps,
    })

    const [map, setMap] = useState<google.maps.Map | null>(null)

    useEffect(() => {
        setDefaults({
            key: keyMaps,
            language: "pt",
            region: "br",
            outputFormat: OutputFormat.JSON
        });
    }, [])

    useEffect(() => {
        if (isLoaded && props.value.latitude && props.value.longitude) {
            setLocalizacao({
                lat: props.value.latitude,
                lng: props.value.longitude
            });
            setCenter({
                lat: props.value.latitude,
                lng: props.value.longitude
            });
        }
    }, [isLoaded, props.value.latitude, props.value.longitude]);

    useEffect(() => {

    }, [localizacao])

    const decomporResultado = (result: any) => {
        const endereco = new Endereco();
        endereco.id = props.value.id;
        result.address_components.map((component: any) => {
            if (component.types.includes("administrative_area_level_1")) {
                endereco.estado = component.short_name;
            } else if (component.types.includes("administrative_area_level_2")) {
                endereco.cidade = component.short_name;
            } else if (component.types.includes("sublocality")) {
                endereco.bairro = component.short_name;
            } else if (component.types.includes("postal_code")) {
                endereco.cep = component.short_name;
            } else if (component.types.includes("route")) {
                endereco.logradouro = component.short_name;
            } else if (component.types.includes("street_number")) {
                endereco.numero = Number(component.short_name);
            }
        })
        
        endereco.latitude = result.geometry.location.lat || 0;
        endereco.longitude = result.geometry.location.lng || 0;
        props.onChange(endereco);
    }

    const completeMethod = (e: { query: string }) => {
        geocode(RequestType.ADDRESS, e.query)
            .then(({ results }) => {
                setSugestoes(results);
            })
            .catch(console.error);
    }

    return (
        <div>
            <div className="form-container">
                <div className="form-row">
                    <div className="form-item">
                        <Label>Estado</Label>
                        <InputText value={props.value.estado} onChange={(e) => props.onChange({ ...props.value, estado: e.target.value })} placeholder="Estado" />
                    </div>

                    <div className="form-item">
                        <Label>Cidade</Label>
                        <InputText value={props.value.cidade} onChange={(e) => props.onChange({ ...props.value, cidade: e.target.value })} placeholder="Cidade" />
                    </div>
                    <div className="form-item">
                        <Label>Bairro</Label>
                        <InputText value={props.value.bairro} onChange={(e) => props.onChange({ ...props.value, bairro: e.target.value })} placeholder="Bairro" />
                    </div>
                    <div className="form-item">
                        <Label>CEP</Label>
                        <InputText value={props.value.cep} onChange={(e) => props.onChange({ ...props.value, cep: e.target.value })} placeholder="CEP" />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-item">
                        <Label>Logradouro</Label>
                        <InputText value={props.value.logradouro} onChange={(e) => props.onChange({ ...props.value, logradouro: e.target.value })} placeholder="Logradouro" />
                    </div>
                    <div className="form-item">
                        <Label>Número</Label>
                        <InputText value={(props.value.numero || 0) + ""} onChange={(e) => props.onChange({ ...props.value, numero: Number(e.target.value) })} placeholder="Número" />
                    </div>
                    <div className="form-item">
                        <Label>Complemento</Label>
                        <InputText value={props.value.complemento} onChange={(e) => props.onChange({ ...props.value, complemento: e.target.value })} placeholder="Complemento" />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-item">
                        <Label>Observação</Label>
                        <InputTextarea className="textarea-item" placeholder="Digite informações adicionais aqui" value={props.value.observacao + ""} onChange={(e) => props.onChange({ ...props.value, observacao: e.target.value })} />
                    </div>
                </div>
            </div>

            <AutoComplete value={termoBusca} suggestions={sugestoes} completeMethod={completeMethod} field="formatted_address"
                inputStyle={{ width: "824px" }} style={{ width: "824px", marginTop: 16 }}
                placeholder="Buscar endereço"

                onChange={(e) => {
                    if (typeof e.target.value === "string") {
                        setTermoBusca(e.target.value)
                    } else {
                        setLocalizacao(e.target.value.geometry.location)
                        decomporResultado(e.target.value);
                        setCenter(e.target.value.geometry.location)
                        setTermoBusca("")
                    }

                }} />
            {isLoaded ? <GoogleMap
                onLoad={(map) => {
                    const bounds = new window.google.maps.LatLngBounds(center)
                    map.fitBounds(bounds)
                    var listener = google.maps.event.addListener(map, "idle", function () {
                        if ((map.getZoom() || 0) > 15) map.setZoom(15);
                        google.maps.event.removeListener(listener);
                    })
                    setMap(map);
                }}
                zoom={15}
                center={center}
                onUnmount={() => { }}
                mapContainerStyle={{
                    height: "400px",
                    width: "824px"
                }}
                onClick={(e) => {
                    if (e.latLng) {
                        setLocalizacao({ lat: e.latLng.lat(), lng: e.latLng.lng() })

                        fromLatLng(e.latLng.lat(), e.latLng.lng())
                            .then(({ results }) => {
                                decomporResultado(results[0]);
                            })
                            .catch(console.error);

                    }
                }}
            >
                {localizacao ? <Marker position={localizacao} /> : null}
            </GoogleMap> : null}
        </div>
    )
}